(function(window, angular) {'use strict';

	var app = angular.module('app');

	/**
	 *
	 * task App Controller
	 *
	 */
	app.controller('taskFormController',
		['$scope', 'taskService', 'userService', '$filter', '$timeout', '$window',
		function($scope, taskService, userService, $filter, $timeout,    $window) {
		$scope.my_user_id = null;
		$scope.users = {};
		$scope.task = {
			priority:'low',
			status:'todo',
			users:[],
		};
		$scope.logs	= [];

		/**
		 * init controller
		 * @return {none}
		 */
		$scope.init = function(my_user_id, task_id) {
			$scope.my_user_id = my_user_id;

			$scope.loading = true;
			userService.search().then(function(users) {
				$scope.users = {
					array:users,
				};
				angular.forEach(users, function(user, idx) {
					$scope.users['id' + user.id] = user;
				});
				$scope.loading = false;

				// init with me (for create task)
				$scope.task.users.push( $scope.getUser($scope.my_user_id) );

				if( task_id ) {
					$scope.loading = true;
					taskService.get(task_id).then(function(task) {
						$scope.task = task;
						$scope.loading = false;

						$scope.initTask(task);
					}, function(error) {
						$scope.loading = false;
					});
				}
				else {
					// create
					$scope.task.is_editing = true;
				}
			});
		}

		/**
		 * initTask
		 * @param  {object} task
		 * @return {none}
		 */
		$scope.initTask = function(task) {
			$scope.task = task;

			task.is_editing   = false; // show form
			task.is_mine      = task.user_id == $scope.my_user_id;
			task.user         = $scope.getUser(task.user_id);
			task.is_delegate  = false;

			angular.forEach(task.users, function(user, idx) {
				if( user.id == $scope.my_user_id ) {
					task.is_delegate = true;
				}
			});

			// load comments and logs
			$scope.loading_comments = true;
			$scope.logs = [];
			taskService.searchComments(task).then(function(response) {
				angular.forEach(response.data, function(comment, idx) {
					$scope.pushLog(comment);
				});
				$scope.loading_comments = false;
			}, function(error) {
				$scope.loading_comments = false;
			});

			taskService.searchLogs(task).then(function(response) {
				angular.forEach(response.data, function(log, idx) {
					$scope.pushLog(log);
				});
			});

			taskService.markCommentsAsRead(task);

			// update badges
			menuTasksCount();
		}

		$scope.getUser = function(user_id) {
			return $scope.users['id' + user_id];
		}

		$scope.togglePriority = function(priority) {
			$scope.task.priority = $scope.task.priority == priority ? 'low' : priority;
		}

		$scope.pushLog = function(data) {
			data.created_at = new Date(data.created_at);

			data.is_mine = false;
			if( data.user_id ) {
				data.user = $scope.getUser(data.user_id);
				data.is_mine = data.user_id == $scope.my_user_id ? true : false;
			}
			if( data.updated_by_user_id ) {
				data.updated_by_user = $scope.getUser(data.updated_by_user_id);
			}

			if( data.comment ) {
				data.is_editable  = data.updated_by_user_id == $scope.my_user_id ? true : false;
				data.is_deletable = $scope.task.user_id == $scope.my_user_id || data.is_editable ? true : false;
			}

			$scope.logs.push(data);
		}

		$scope.deleteComment = function(comment) {
			if( !comment.id ) {
				return;
			}
			var idx = $scope.logs.indexOf(comment);
			var remove = function() {
				$scope.logs.splice(idx, 1);
			}

			if( idx != -1 ) {
				$scope.loading = true;
				taskService.deleteComment($scope.task, comment).then(function() {
					$scope.loading = false;
					remove();
				}, function(error) {
					$scope.loading = false;
				});
			}
			else {
				remove();
			}
		}

		$scope.addComment = function(new_comment, form) {
			if( !$scope.task.id ) {
				return;
			}

			taskService.saveComment($scope.task, angular.copy(new_comment)).then(function(comment) {
				$scope.pushLog(comment);
				new_comment.comment = '';
			}, function(error) {
				$scope.handleError(error, form);
			});
		}

		$scope.editComment = function(comment) {
			comment.is_editing = true;
			comment.new_comment = comment.comment;
		}

		$scope.saveComment = function(comment) {
			if( comment.new_comment && comment.new_comment.length ) {
				comment.comment = comment.new_comment;
			}

			$scope.loading = true;
			taskService.saveComment($scope.task, comment).then(function(comment) {
				$scope.loading = false;
				comment.is_editing = false;
			}, function(error) {
				$scope.loading = false;
			});
		}

		$scope.saveTask = function(form) {
			if( form.$invalid ) {
				form.show_errors = true;
				return;
			}

			form.show_errors = false;
			form.errors = [];

			$scope.loading = true;
			taskService.save($scope.task).then(function(task) {
				$scope.loading = false;
				task.is_editing = false;
				$scope.initTask(task);
			}, function(error) {
				$scope.handleError(error, form);
				$scope.loading = false;
			});
		}

		/**
		 * toggle task status
		 * @param  {object} task to modify
		 * @return {none}
		 */
		$scope.toggleStatus = function() {
			// update the status
			var status_finished = $scope.task.is_mine ? 'closed' : 'done';
			$scope.task.status = $scope.task.status == status_finished ? 'todo' : status_finished;

			$scope.loading = true;
			taskService.save($scope.task).then(function(updated_task) {
				$scope.loading = false;
				$scope.initTask(updated_task);
			}, function(error) {
				$scope.loading = false;
			});
		}
	}]);

})(window, window.angular);
